"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.World = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var World = function World(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#World_svg__World_svg__clip0_17455_92032)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-8 6.4c.182 0 .415-.08.694-.345.284-.27.575-.698.838-1.289.201-.453.376-.98.515-1.566H5.953c.14.586.314 1.113.515 1.566.263.59.554 1.019.838 1.289.28.266.512.345.694.345zM5.684 9.6h4.632a15.114 15.114 0 000-3.2H5.684a15.125 15.125 0 000 3.2zm.27-4.8a8.99 8.99 0 01.514-1.566c.263-.59.554-1.019.838-1.289.28-.266.512-.345.694-.345.182 0 .415.08.694.345.284.27.575.698.838 1.289.201.453.376.98.515 1.566H5.953zm5.97 1.6a16.789 16.789 0 010 3.2h2.274a6.413 6.413 0 000-3.2h-2.274zm1.62-1.6h-1.859a10.971 10.971 0 00-.691-2.216 7.884 7.884 0 00-.15-.32 6.429 6.429 0 012.7 2.536zm-9.23 0H2.457a6.429 6.429 0 012.7-2.535c-.051.104-.102.21-.15.319A10.97 10.97 0 004.315 4.8zM1.803 6.4h2.273a16.809 16.809 0 000 3.2H1.802a6.411 6.411 0 010-3.2zm9.192 7.016a10.93 10.93 0 00.691-2.216h1.859a6.428 6.428 0 01-2.7 2.535 7.87 7.87 0 00.15-.319zm-5.838.32a6.428 6.428 0 01-2.7-2.536h1.859c.17.819.403 1.568.691 2.216.048.109.099.215.15.32z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "World_svg__World_svg__clip0_17455_92032"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
};

exports.World = World;
var _default = World;
exports.default = _default;